// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgRandome24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.1814 4.41438C18.5048 4.15562 18.9768 4.20806 19.2356 4.53151L21.1356 6.90657C21.4132 7.25352 21.4132 7.74653 21.1356 8.09349L19.2356 10.4685C18.9768 10.792 18.5048 10.8444 18.1814 10.5857C17.8579 10.3269 17.8055 9.85495 18.0643 9.53151L19.0895 8.25H15.139C15.0618 8.25 14.989 8.28562 14.9416 8.34651L12.1001 12L14.9416 15.6534C14.989 15.7143 15.0618 15.7499 15.139 15.7499H19.0894L18.0643 14.4685C17.8055 14.145 17.8579 13.6731 18.1814 13.4143C18.5048 13.1555 18.9768 13.208 19.2356 13.5314L21.1356 15.9065C21.4132 16.2534 21.4132 16.7465 21.1356 17.0934L19.2356 19.4685C18.9768 19.7919 18.5048 19.8444 18.1814 19.5856C17.8579 19.3268 17.8055 18.8549 18.0643 18.5314L19.0894 17.2499H15.139C14.599 17.2499 14.0892 17.0006 13.7576 16.5743L11.1499 13.2216L8.54218 16.5744C8.21064 17.0007 7.70085 17.25 7.16082 17.25H3.1499C2.73569 17.25 2.3999 16.9142 2.3999 16.5C2.3999 16.0858 2.73569 15.75 3.1499 15.75H7.16082C7.23797 15.75 7.31079 15.7144 7.35816 15.6535L10.1998 12L7.35816 8.34646C7.31079 8.28557 7.23797 8.24995 7.16082 8.24995H3.1499C2.73569 8.24995 2.3999 7.91416 2.3999 7.49995C2.3999 7.08574 2.73569 6.74995 3.1499 6.74995H7.16082C7.70085 6.74995 8.21064 6.99928 8.54218 7.42555L11.1499 10.7784L13.7576 7.4256C14.0892 6.99933 14.599 6.75 15.139 6.75H19.0894L18.0643 5.46855C17.8055 5.1451 17.8579 4.67313 18.1814 4.41438Z"
				/>
			</Svg>
		);
	}
);
SvgRandome24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgRandome24;
